import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const NumberChart = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      d="M10.5,21.5l-4.3,4.7l-1.4-1.5l6-6.4h2.1v27.3h-2.3L10.5,21.5L10.5,21.5z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M18.4,43.7c9.2-7.5,15.4-12.8,15.4-18.1c0-3.9-3.2-5.6-6.2-5.6c-3.4,0-6,1.5-7.4,3.6l-1.6-1.5c1.9-2.6,5.2-4.2,9-4.2c4,0,8.5,2.3,8.5,7.7c0,6-6.3,11.5-14.1,17.9h14.2v2.1H18.4V43.7z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M42.6,40.2c1.5,2.2,4.1,3.8,7.6,3.8c4.2,0,6.8-2.2,6.8-5.8c0-3.9-3.2-5.5-7.3-5.5c-1.1,0-2.1,0-2.5,0v-2.2c0.4,0,1.4,0,2.5,0c3.6,0,6.8-1.6,6.8-5.2c0-3.4-3-5.3-6.5-5.3c-3.1,0-5.3,1.2-7.3,3.5L41.4,22c1.9-2.3,4.9-4.1,8.8-4.1c4.7,0,8.7,2.6,8.7,7.2c0,4.2-3.5,6-5.8,6.4c2.3,0.2,6.2,2.3,6.2,6.8s-3.4,7.8-9.1,7.8c-4.4,0-7.7-2.1-9.2-4.6L42.6,40.2z"
    />
  </SvgIcon>
);
